import axios from "axios";
import Swal from "sweetalert2";

export const handleOnePayReturn = async (
  setLoading,
  navigate,
  childrenAgeRule
) => {
  const urlParams = new URLSearchParams(window.location.search);
  const responseCode = urlParams.get("vpc_ResponseCode");
  const orderId = urlParams.get("vpc_MerchTxnRef"); // Retrieve order ID

  if (responseCode) {
    setLoading(true);
    if (responseCode === "0") {
      try {
        console.log(`OnePay Transaction Successful. Order ID: ${orderId}`);
        const response = await axios.get(`/api/payment/onepay/return`, {
          params: { vpc_MerchTxnRef: orderId },
        });

        Swal.fire({
          title: "Success",
          text: "Your reservation was booked successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          const hotelInfo = response.data.hotelInfo; // Assume the backend returns hotel info
          const booking = response.data.booking; // Assume the backend returns booking details
          navigate("/confirmation", {
            state: { booking, hotelInfo, childrenAgeRule },
          });
        });
      } catch (error) {
        console.error(
          `Error verifying OnePay payment for Order ID: ${orderId}`,
          error
        );
        Swal.fire(
          "Error",
          "Failed to verify payment. Please contact support.",
          "error"
        );
      }
    } else {
      console.error(`OnePay Transaction Failed. Order ID: ${orderId}`);
      Swal.fire(
        "Payment Failed",
        "OnePay transaction failed. Please try again.",
        "error"
      );
    }
    setLoading(false);
  }
};
